import React, { useState } from 'react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { TICKETS } from '@/constants/testIds';
import api from '@/lib/api';
import { Ticket, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const BuyTicketsModal = ({ event, open, onOpenChange }) => {
  const [quantity, setQuantity] = useState(1);
  const [loading, setLoading] = useState(false);

  const checkout = async () => {
    setLoading(true);
    try {
      const { data } = await api.post('/payments/tickets/checkout', {
        event_id: event.event_id,
        quantity: parseInt(quantity) || 1,
        origin_url: window.location.origin,
      });
      window.location.href = data.url;
    } catch (err) {
      toast.error('Could not start checkout', { description: err?.response?.data?.detail });
      setLoading(false);
    }
  };

  const subtotal = (event.ticket_price || 0) * quantity;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="glass-strong border-white/10 text-slate-100 max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Buy tickets</DialogTitle>
          <DialogDescription className="text-slate-400 truncate">{event.title}</DialogDescription>
        </DialogHeader>
        <div className="space-y-5 mt-2">
          <div>
            <Label className="text-xs text-slate-400 uppercase tracking-wider">Quantity</Label>
            <Input
              type="number" min="1" max="10" value={quantity}
              onChange={(e) => setQuantity(Math.max(1, Math.min(10, parseInt(e.target.value) || 1)))}
              data-testid={TICKETS.quantityInput}
              className="bg-white/5 border-white/10 mt-1"
            />
          </div>
          <div className="rounded-2xl bg-white/5 border border-white/10 p-5 space-y-2 text-sm">
            <div className="flex justify-between text-slate-300">
              <span>Price per ticket</span>
              <span>₹{(event.ticket_price || 0).toLocaleString('en-IN')}</span>
            </div>
            <div className="flex justify-between text-slate-300">
              <span>Quantity</span><span>×{quantity}</span>
            </div>
            <div className="border-t border-white/10 pt-2 flex justify-between text-white font-semibold">
              <span>Total</span><span className="font-display text-lg">₹{subtotal.toLocaleString('en-IN')}</span>
            </div>
          </div>
          <Button
            onClick={checkout} disabled={loading || !event.ticket_price}
            data-testid={TICKETS.checkoutButton}
            className="w-full btn-rainbow text-white border-0 rounded-xl py-6 text-base"
          >
            {loading ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" />Redirecting…</> : <><Ticket className="h-4 w-4 mr-2" />Pay with Stripe</>}
          </Button>
          <p className="text-[11px] text-slate-500 text-center">Test mode — use card 4242 4242 4242 4242</p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BuyTicketsModal;
